export const featureFlagKeys = {
  enableMaintenanceBanner: 'enable-maintenance-banner',
  enableHeadlessUiAnchor: 'enable-headless-ui-anchor',
  enableCommunityReports: 'enable-community-reports',
  enableCommunityTiptapPostEditor: 'enable-community-tiptap-post-editor',
} as const

export type FeatureFlagKey = (typeof featureFlagKeys)[keyof typeof featureFlagKeys]
